// axios 默认配置
// eslint-disable-next-line
import qs from 'qs';

const AXIOS_DEFAULT_CONFIG = {
  // url` is the server URL that will be used for the request
  // url: '/user',

  // `method`是发出请求时使用的请求方法
  // method: 'get', // default

  // `baseURL`将被添加到`url`，除非`url`是绝对的。
  // 为axios实例设置`baseURL`以传递相对URL可能很方便
  // 对那个实例的方法。
  // baseURL: 'https://some-domain.com/api/',

  // `transformRequest`允许在将请求数据发送到服务器之前对其进行更改
  // 这仅适用于请求方法'PUT'，'POST'，'PATCH' 和'DELETE'
  // 数组中的最后一个函数必须返回一个字符串或Buffer，ArrayBuffer的实例，
  //  FormData或Stream
  // 您可以修改标题对象。
  // transformRequest: [function (data, headers) {
  //   // 做你想要转换数据的任何事情

  //   return data;
  // }],

  // `transformResponse`允许更改之前的响应数据
  // 它被传递给then / catch
  // transformResponse: [function (data) {
  //   // 做你想改变数据的任何东西

  //   return data;
  // }],

  // `headers`是要发送的自定义标头
  // headers: {
  //   'SameSite': 'None',
  //   'X-Requested-With': 'XMLHttpRequest'
  // },

  // `params`是与请求一起发送的URL参数
  // 必须是普通对象或URLSearchParams对象
  // 如果要测试，请覆盖该对象
  params: {},

  // `paramsSerializer`是一个可选函数，负责序列化`params`
  // （例如https://www.npmjs.com/package/qs,http://api.jquery.com/jquery.param/）
  paramsSerializer(params) {
    // 序列化参数
    return qs.stringify(params);
  },

  // `data`是要作为请求体发送的数据
  // 仅适用于请求方法'PUT'，'POST' 和'PATCH'
  // 当没有设置`transformRequest`时，必须是以下类型之一：
  //  - 字符串，普通对象，ArrayBuffer，ArrayBufferView，URLSearchParams
  //  - 仅限浏览器：FormData，File，Blob
  //  - 仅限节点：流，缓冲区
  // data: {
  //   firstName: 'Fred'
  // },

  // `timeout`指定请求超时前的毫秒数。
  // 如果请求的时间超过“超时”，请求将被中止。
  timeout: 15000, // default is `0` (no timeout)

  // `withCredentials`表示是否跨站点访问控制请求
  // 应该使用凭证制作
  // withCredentials: false, // default

  // “adapter”允许自定义处理请求，使测试更容易。
  // 返回一个promise并提供一个有效的响应（参见lib / adapters / README.md）。
  // adapter: function(config) {
  //   /* ... */
  // },

  // `auth`表示应该使用HTTP Basic auth，并提供凭据。
  // 这将设置一个`Authorization`标题，覆盖任何现有标题
  // 使用`headers`设置的`Authorization`自定义标题。
  // 请注意，只有HTTP Basic auth可以通过此参数进行配置。
  // 对于Bearer令牌等，请改用“Authorization”自定义标头。
  // auth: {
  //   username: 'janedoe',
  //   password: 's00pers3cret'
  // },

  // `responseType`表示服务器将响应的数据类型
  // 选项包括：'arraybuffer'，'document'，'json'，'text'，'stream'
  // 仅限浏览器：'blob'
  // responseType: 'json', // default

  // `responseEncoding`表示用于解码响应的编码
  // 注意：忽略“stream”或“客户端”请求的“responseType”
  // responseEncoding: 'utf8', // default

  // `xsrfCookieName`是用作xsrf标记值的cookie的名称
  // xsrfCookieName: 'XSRF-TOKEN', // default

  // `xsrfHeaderName`是带有xsrf标记值的http标头的名称
  // xsrfHeaderName: 'X-XSRF-TOKEN', // default

  // `onUploadProgress`允许处理上传的进度事件
  // onUploadProgress: function (progressEvent) {
  // 使用本机进度事件执行任何操作
  // },


  // `onDownloadProgress`允许处理下载的进度事件
  // onDownloadProgress: function (progressEvent) {
  // Do whatever you want with the native progress event
  // 使用本机进度事件执行任何操作
  // },

  // `maxContentLength`定义了允许的以字节为单位的http响应内容的最大大小
  // maxContentLength: 2000,

  // `validateStatus`定义是否解析或拒绝给定的承诺
  // HTTP响应状态代码。 如果`validateStatus`返回`true`（或设置为`null`
  // 或“未定义”），承诺将得到解决; 否则，承诺将是
  // 被拒绝。
  validateStatus(status) {
    // 只过滤出2开头的状态，其他状态通通列为失败
    return /^[2,4]\d{2}$/.test(status);
  },

  // `maxRedirects`定义了node.js中要遵循的最大重定向数。
  // 如果设置为0，则不会遵循重定向。
  // maxRedirects: 5, // default

  // `socketPath`定义了一个在node.js中使用的UNIX套接字。
  // 例如 '/var/run/docker.sock' 将请求发送到docker守护程序。
  // 只能指定`socketPath`或`proxy`。
  // 如果同时指定了两者，则使用`socketPath`。
  // socketPath: null, // default

  // `httpAgent`和`httpsAgent`定义了执行http时要使用的自定义代理
  // 和node.js中的https请求。 这允许添加选项
  // “keepAlive”默认情况下未启用。
  // httpAgent: new http.Agent({ keepAlive: true }),
  // httpsAgent: new https.Agent({ keepAlive: true }),


  // 'proxy' 定义代理服务器的主机名和端口。
  // 您还可以使用传统的`http_proxy`和
  // “https_proxy”环境变量来定义代理。如果您使用环境变量
  // 代理配置，您还可以将`no_proxy`环境
  // 变量定义为不应代理的以逗号分隔的域列表。
  // 使用`false`来禁用代理，忽略环境变量。
  // `auth`表示应使用HTTP Basic auth连接到代理，
  // 提供凭据。
  // 这将设置一个`Proxy-Authorization`标头，覆盖你使用`headers`设置的任何现有的``Proxy-Authorization`自定义标头。
  // proxy: {
  //   host: '127.0.0.1',
  //   port: 9000,
  //   auth: {
  //     username: 'mikeymike',
  //     password: 'rapunz3l'
  //   }
  // },

  // `cancelToken`指定可用于取消请求的取消令牌
  // （有关详细信息，请参阅下面的取消部分）
  // 每次传同一个token可以统一取消
  // cancelToken: SOURCE_TOKEN.token
};

export default AXIOS_DEFAULT_CONFIG;
